<template>
    <div name="uncomfortable">
        <navigation-bar 
            @change="change"
        />
        <router-view />
    </div>
</template>

<script>
import NavigationBar from '@/components/molecules/pc_uncomfortable/NavigationBar'
export default {
    components: { NavigationBar },
    name: 'uncomfortable',
    mounted: function()
    {
        // 모바일을 감지
        if(!this.isPC())
        {
            this.$router.push({path: `/m${this.$route.path}`})
        }
    },  
    methods: {
        change: function(route)
        {
            this.$router.push({path: route})
        },
        isPC:function () {
            const userAgent = navigator.userAgent.toLowerCase();
            const isMobile = /iphone|ipod|android|blackberry|windows phone|opera mini|iemobile|mobile/i.test(userAgent);
            return !isMobile;
        },
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/page/pc_uncomfortable/Uncomfortable.vue